<!-- 音像核验 -->

<template>
  <div class="admin-2">
    <div class="provinceArea" :style="leftHt">
      <el-scrollbar ref="aaa">
        <el-menu
          :default-active="postDat.sjExamineId"
          class="el-menu-vertical-demo"
          background-color="#fff"
          active-text-color="#409EFF"
          @select="provinceChange">
          <!-- :disabled="ableSet(item.status)" -->
          <el-menu-item
            v-for="(item, inx) in provinceList"
            :index="item.sjExamineId"
            :key="inx"
            :style="{ ...computedColor(item) }"
            :class="{ 'custom-active': postDat.sjExamineId == item.sjExamineId }">
            <span slot="title">{{ item | transStr("navset") }}</span>
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
    </div>
    <div v-if="postDat.sjExamineId" class="contArea">
      <div class="ttBar">
        <span>{{ pvcName }}</span>
        <i class="el-icon-arrow-right"></i>
        <span>音像制品出版单位核验</span>

        <div class="btnCtrls">
          <el-button @click="postBack(1)" size="small" type="danger">整体发布</el-button>
          <el-button
            v-if="pvcSta == 0"
            @click="
              dialogVisible = true;
              postDat.msg == '';
            "
            size="small"
            type="primary"
            >整体退回</el-button
          >

          <a @click="goUrl(postUrl)" download v-if="postUrl">
            <el-button size="small">省局分析报告</el-button>
          </a>
          <el-button v-else disabled size="small" style="width: 180px">省局分析报告（未上传）</el-button>

          <a @click="goUrl(postUrlZg)" download v-if="postUrlZg">
            <el-button size="small">省局整改报告</el-button>
          </a>
          <!-- <el-button v-else disabled size="small" style="width:180px;">省局整改报告（未上传）</el-button> -->
        </div>
      </div>

      <div class="tabArea">
        <div class="ctrlsBar">
          <el-menu
            :default-active="activeIndex"
            class="menuButton"
            mode="horizontal"
            background-color="#409EFF"
            text-color="#fff"
            active-text-color="fff"
            @select="handleSelect">
            <el-submenu :show-timeout="0" :hide-timeout="0" index="2">
              <template slot="title">核验意见</template>
              <el-menu-item index="1">通过</el-menu-item>
              <el-menu-item index="2">暂缓登记</el-menu-item>
              <el-menu-item index="5">注销或拟注销</el-menu-item>
              <el-menu-item index="4">撤销</el-menu-item>
              <el-menu-item index="3">退回</el-menu-item>
              <!-- <el-menu-item index="22">暂缓登记</el-menu-item> -->
            </el-submenu>
            <!--          </el-submenu>-->
          </el-menu>

          <div class="blockRt">
            <el-select v-model="postDat.status" @change="tabSeek('init')" size="small" placeholder="请选择">
              <el-option v-for="item in typeArr" :key="item.key" :label="item.name" :value="item.key"> </el-option>
            </el-select>

            <el-input v-model="postDat.keyword" size="small" placeholder="通过单位名称查询"></el-input>
            <!-- <el-button @click="tabSeek('init')" size="small">查询</el-button> -->
          </div>
        </div>
        <div>
          <el-table :data="tabDats" border style="width: 100%" @selection-change="selectionChange" v-loading="loading">
            <el-table-column :selectable="checkDfine" type="selection" width="45" align="center"></el-table-column>
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 + 15 * (postDat.no - 1) }}
              </template>
            </el-table-column>
            <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
            <!-- <el-table-column width="150" label="状态" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row | transStr("state") }}</span>
              </template>
            </el-table-column> -->
            <el-table-column width="90" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.status == 0 ||
                    scope.row.status == 1 ||
                    scope.row.status == 2 ||
                    scope.row.status == 4 ||
                    scope.row.status == 5
                  "
                  @click="goFirm(scope.row, 1)"
                  type="primary"
                  size="mini"
                  >进入
                </el-button>
                <el-button v-else @click="goFirm(scope.row, 2)" type="primary" size="mini">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column width="100" label="批准文号" prop="pubNumber" align="center"> </el-table-column>
            <el-table-column width="100" label="省局意见" prop="statussj" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row | transStr("statussj") }}</span>
                <!-- <span>{{ scope.row | transStr("examineMessage") }}</span> -->
              </template>
            </el-table-column>
            <el-table-column width="120" label="国家新闻出版署意见" prop="statuszj" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row | transZjStr("statuszj") }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150" label="查阅时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.provinceConsult | transStr("time") }}
              </template>
            </el-table-column>
          </el-table>

          <div class="pageCage" v-if="postDat.total > 1">
            <el-pagination
              @current-change="pageSent"
              :current-page="postDat.no"
              layout="prev, pager, next"
              :page-count="postDat.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="unProvince" v-else></div>

    <el-dialog class="admin_audio_pop" title="" :visible.sync="dialogVisible" @close="closeHandle" width="450px">
      <div class="ppttl">
        <span>请填写整体退回意见</span>
      </div>
      <el-input v-model="postDat.msg" rows="5" placeholder="请输入内容" type="textarea"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button @click="postBack(2)" type="primary" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <!--核验意见新增的退回说明-->
    <el-dialog class="admin_audio_pop" title="请填写意见" width="40%" center :visible.sync="dialogShow">
      <div class="ppttl">
        <span v-if="paramsEx.status == 3">请填写退回意见</span>
        <span v-if="paramsEx.status == 22">请填写整改意见</span>
        <span v-if="paramsEx.status == 2">请填写暂缓意见</span>
        <span v-if="paramsEx.status == 4">请填写撤销意见</span>
        <span v-if="paramsEx.status == 5">请填写注销意见</span>
      </div>
      <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="paramsEx.message"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="returnFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProviceList,
  getWaitList,
  adminExam, // zym.进行审核
  postToPvs, // zym.整体发布
  backToPvs, // zym.整体退回
} from "@/api/adminRole/adminRole";
import {
  ssReportLoad, // zym.分析报告查询
  getPostponeDesc, // zym.整改报告查询
} from "@/api/provinceRole/provinceRole";
import { getPfileUrl } from "@/api/pressRole/pressRole";
import { getFileToken } from "@/api/account";
import { computed } from "vue";
export default {
  data() {
    return {
      activeIndex: "1",
      leftHt: 0,
      screenHeight: "",
      loading: false,
      // typeArr: [
      //   {
      //     name: "全部",
      //     key: 99,
      //   },
      //   {
      //     name: "待核验",
      //     key: 0,
      //   },
      //   {
      //     name: "通过",
      //     key: 1,
      //   },
      //   {
      //     name: "暂缓登记",
      //     key: 2,
      //   },
      //   {
      //     name: "撤销",
      //     key: 4,
      //   },
      //   {
      //     name: "注销或拟注销",
      //     key: 5,
      //   },
      //   {
      //     name: "退回",
      //     key: 98,
      //   },
      // ],
      typeArr: [
        {
          name: "全部",
          key: 99,
        },
        {
          name: "待核验",
          key: 0,
        },
        {
          name: "通过",
          key: 1,
        },
        {
          name: "暂缓登记",
          key: 21,
        },
        {
          name: "已登记",
          key: 11,
        },
        {
          name: "注销或拟注销",
          key: 13,
        },
      ],

      postDat: {
        type: 1,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        msg: "",

        no: 1,
        size: 15,
      },

      paramsEx: {
        ids: [],
        type: "",
        status: 1,
        message: "",
        pubNumber: "",
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0,

      provinceList: [],
      provinceMap: {},

      pvcName: "",
      pvcSta: "",
      fileToken: "",
      postUrl: "", // zym.省局的分析报告
      postUrlZg: "", // zym.省局的整改报告

      // 整体退回意见
      dialogVisible: false,
      // 核验新增退回操作
      dialogShow: false,
    };
  },
  filters: {
    transZjStr: function (dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        let map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布",
        };
        return map[dat.statuszj];
      }
    },
    transStr: function (dat, code) {
      if (code == "state") {
        let map = {
          0: "待核验",
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          4: "撤销",
          5: "注销或拟注销",
          10: "整体退回",
          9: "整体发布",
        };
        if (dat.status == 9) {
          return map[dat.pubStatus] + "（已发布）";
        } else {
          return map[dat.status];
        }
      } else if (code == "statussj") {
        let map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          // 9: "整体提交",
          11: "已登记",

          // 12: "省局暂缓",
          13: "注销或拟注销",
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      } else if (code == "navset") {
        // zym.20250321，去掉各种情况的判断，直接返回省局名称
        // if (dat.status == 0) {
        //   return dat.sjExamine;
        // } else if (dat.status == 8) {
        //   return dat.sjExamine + "（未提交）";
        // } else if (dat.status == 9) {
        //   return dat.sjExamine + "（已完成）";
        // } else if (dat.status == 10) {
        //   return dat.sjExamine + "（退回）";
        // }
        return dat.sjExamine;
      } else if (code == "time") {
        if (dat == "Invalid date" || !dat) {
          return "";
        }
        return dat.substr(0, 16);
      } else if (code == "examineMessage") {
        return dat.examineMessage;
      }
    },
  },
  // watch: {
  //   // screenHeight:function(val){
  //   // this.leftHt = "height:" + val + "px";
  //   // this.$refs.aaa.update();
  //   // this.$message.error('aaa');
  //   // console.log(this.leftHt);

  //   // }
  // },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      },
    },
  },
  methods: {
    goUrl: function (url) {
      window.open(url);
    },
    resizeSet: function () {
      this.leftHt = document.documentElement.clientHeight - 50;
      window.onresize = function () {
        this.leftHt = document.documentElement.clientHeight - 50;
      };

      this.leftHt = "height:" + this.leftHt + "px";
    },

    // zym.查询某个省份的待审核的数据
    tabSeek: function (code) {
      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      getWaitList(this.postDat).then((response) => {
        this.tabDatsAll = response.fGeneralExamineList;
        // this.pgAll = response.totalPages;
        this.loading = false;

        this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function () {
      let tabDats = this.tabDatsAll;

      let qType = this.postDat.status;
      let qKeyword = this.postDat.keyword;
      // !状态
      let statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        // tabDats = tabDats.filter(function (item) {
        //   // zym.待核验
        //   if (qType == 0 && item.status == "0") {
        //     return true;
        //   } else if (qType == 1 && item.status == "1") {
        //     return true;
        //   } else if (qType == 2 && item.status == "2") {
        //     return true;
        //   } else if (qType == 4 && item.status == "4") {
        //     return true;
        //   } else if (qType == 5 && item.status == "5") {
        //     return true;
        //   } else if (qType == 98 && (item.status == "3" || item.status == "10")) {
        //     return true;
        //   }
        //   return false;
        // });
        // console.log("qType=", qType);
        tabDats = tabDats.filter(function (item) {
          // console.log("item.statussj=", item.organizationName, "   ", item.statussj);
          let statussj = item.statussj + "";
          if (qType == 1 && statussj == "1") {
            return true;
          } else if (qType == 21 && statussj == "21") {
            return true;
          } else if (qType == 11 && statussj == "11") {
            return true;
          } else if (qType == 13 && statussj == "13") {
            return true;
          } else if (qType == 0 && ["1", "21", "11", "13"].indexOf(statussj) == -1) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function (tabDatsTemp) {
      let postDat = this.postDat;
      let tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      let dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      let size = Number(postDat.size);
      // console.log('size=',size);
      let total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },

    // zym.省局设置
    provinceSet: function () {
      this.postUrl = "";
      this.postUrlZg = "";

      let vm = this;
      getProviceList({
        type: 1,
      }).then((response) => {
        this.provinceList = response.proList;
        if (!this.postDat.sjExamineId) {
          for (let i in this.provinceList) {
            let pstas = this.provinceList[i].status;
            if (pstas == 0 || pstas == 1 || pstas == 9) {
              this.postDat.sjExamineId = this.provinceList[i].sjExamineId;
              this.pvcName = this.provinceList[i].sjExamine;
              this.pvcSta = this.provinceList[i].status;
              break;
            }
          }
        } else {
          for (let i in this.provinceList) {
            if (this.provinceList[i].sjExamineId == this.postDat.sjExamineId) {
              this.pvcName = this.provinceList[i].sjExamine;
              this.pvcSta = this.provinceList[i].status;
              break;
            }
          }
        }
        for (let i in this.provinceList) {
          this.provinceMap[this.provinceList[i].sjExamineId] = this.provinceList[i];
        }
        if (this.postDat.sjExamineId) {
          ssReportLoad({
            type: 1,
            provinceId: this.postDat.sjExamineId,
          })
            .then((response) => {
              let provinceReport = response.provinceReport;
              if (provinceReport && provinceReport.reportId) {
                getPfileUrl({ id: provinceReport.reportId }).then((response) => {
                  vm.postUrl = response.payload.url;
                  // vm.fileNameHybg = response.payload.fileName
                });
              }
            })
            .catch((error) => {});

          // zym.查询整改报告
          getPostponeDesc({
            type: 1,
            provinceId: this.postDat.sjExamineId,
          })
            .then((response) => {
              let upPostponeDesc = response.upPostponeDesc;
              if (upPostponeDesc && upPostponeDesc.reportId) {
                getPfileUrl({ id: upPostponeDesc.reportId }).then((response) => {
                  vm.postUrlZg = response.payload.url;
                });
              }
            })
            .catch((error) => {});
        }

        this.tabSeek("init");
      });
    },

    // zym.选择核验意见
    handleSelect: function (dat) {
      if (this.paramsEx.ids.length > 0) {
        this.paramsEx.status = dat;
        // zym.退回
        if (dat == 3 || dat == 22 || dat == 2 || dat == 4 || dat == 5) {
          this.dialogShow = true;
          this.paramsEx.message = "";
        } else {
          // let transArr = ["", "通过", "暂缓登记", "", "撤销", "注销或拟注销"];
          let transArrMap = { 0: "", 1: "通过", 2: "暂缓登记", 3: "", 4: "撤销", 5: "注销或拟注销", 22: "暂缓登记" };
          let msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArrMap[this.paramsEx.status] + '" 处理吗？';

          let vm = this;
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              const loading = vm.$loading({
                lock: true,
                text: "处理中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              adminExam(this.paramsEx).then((response) => {
                loading.close();
                let tipCode = response.payload.tipCode;
                let tipMessage = response.payload.tipMessage;
                if (tipCode == "fail") {
                  this.$message({
                    message: tipMessage,
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: tipMessage,
                    type: "success",
                  });
                  this.tabSeek("init");
                }
              });
            })
            .catch(() => {});
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },
    // zym.退回填写完意见后提交服务器
    returnFun: function () {
      // this.paramsEx.message = this.paramsEx.message.replace(/\s+/g, "");
      // if (this.paramsEx.message.length == 0) {
      //   this.$message.error("请输入内容！");
      //   return;
      // }

      this.dialogShow = false;
      let vm = this;
      const loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      adminExam(this.paramsEx).then((response) => {
        loading.close();
        let tipCode = response.payload.tipCode;
        let tipMessage = response.payload.tipMessage;
        if (tipCode == "fail") {
          this.$message({
            message: tipMessage,
            type: "error",
          });
        } else {
          this.$message({
            message: tipMessage,
            type: "success",
          });
          this.tabSeek("init");
        }
      });
    },

    paramsClean: function () {
      this.postDat = {
        type: 1,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        no: 1,
        size: 15,
      };
    },

    // zym.省局切换
    provinceChange: function (inx) {
      this.pvcName = this.provinceMap[inx].sjExamine;
      this.pvcSta = this.provinceMap[inx].status;

      this.paramsClean();
      this.postDat.sjExamineId = inx;
      this.paramsEx.ids = [];
      this.tabSeek();

      let vm = this;

      this.postUrl = "";
      this.postUrlZg = "";
      // zym.省局提交的报告查验
      ssReportLoad({
        type: 1,
        provinceId: inx,
      })
        .then((response) => {
          let provinceReport = response.provinceReport;
          // vm.postUrl = process.env.BASE_API + '/File/File/download/token/' + vm.fileToken + '/id/' + response
          //   .provinceReport.reportId;

          if (provinceReport && provinceReport.reportId) {
            getPfileUrl({ id: provinceReport.reportId }).then((response) => {
              vm.postUrl = response.payload.url;
              // vm.fileNameHybg = response.payload.fileName
            });
          }
        })
        .catch((error) => {});

      // zym.查询整改报告
      getPostponeDesc({
        type: 1,
        provinceId: inx,
      })
        .then((response) => {
          let upPostponeDesc = response.upPostponeDesc;
          if (upPostponeDesc && upPostponeDesc.reportId) {
            getPfileUrl({ id: upPostponeDesc.reportId }).then((response) => {
              vm.postUrlZg = response.payload.url;
            });
          }
        })
        .catch((error) => {});
    },

    goFirm: function (rows, type) {
      this.$router.push({
        path: "admin_fexam",
        query: {
          mtId: rows.materialExamineId,
          pressType: 1,
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: this.postDat.sjExamineId,
          pressName: rows.organizationName,
          examId: rows.id,
          pressState: type,
          updateViewDate: true, // zym.是否更新审阅时间
        },
      });
    },

    selectionChange: function (resDat) {
      this.paramsEx.ids = [];
      for (let i = 0; i < resDat.length; i++) {
        this.paramsEx.ids.push(resDat[i].id);
      }
    },

    // zym.整体退回、整体发布
    // zym.1-发布  2-退回
    postBack: function (code) {
      let vm = this;
      if (code == 1) {
        this.$confirm("确定进行整体发布吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            postToPvs({
              sjExamineId: this.postDat.sjExamineId,
              type: 1,
            }).then((response) => {
              loading.close();
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage || "操作失败";
              if (tipCode == "fail") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage,
                  type: "success",
                  onClose: function () {
                    vm.tabSeek("init");
                  },
                });
              }
            });
          })
          .catch(() => {});
      } else if (code == 2) {
        this.postDat.msg = this.postDat.msg.replace(/\s+/g, "");
        if (this.postDat.msg.length == 0) {
          this.$message.error("请填写退回意见");
        } else {
          this.$confirm("确定进行整体退回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              const loading = vm.$loading({
                lock: true,
                text: "处理中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              backToPvs({
                sjExamineId: this.postDat.sjExamineId,
                examineMessage: this.postDat.msg,
                type: 1,
              }).then((response) => {
                loading.close();

                this.dialogVisible = false;

                let tipCode = response.payload.tipCode;
                let tipMessage = response.payload.tipMessage || "操作失败";
                if (tipCode == "fail") {
                  this.$message({
                    showClose: true,
                    message: tipMessage,
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: tipMessage,
                    type: "success",
                    onClose: function () {
                      vm.tabSeek("init");
                    },
                  });
                }
              });
            })
            .catch(() => {});
        }
      }
    },

    ableSet: function (datIn) {
      if (datIn == 8 || datIn == 10) {
        return true;
      } else {
        return false;
      }
    },

    pageSent: function (inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    closeHandle: function () {
      this.postDat.msg = "";
      this.dialogVisible = false;
    },

    checkDfine: function (dat) {
      if (
        dat.progress != "登记" &&
        (dat.status == 0 || dat.status == 1 || dat.status == 2 || dat.status == 4 || dat.status == 5)
      ) {
        return true;
      } else {
        return false;
      }
      // if (dat.status == 9 || dat.status == 3 || dat.status == 10) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    computedColor: function (item) {
      // if (item.status == 8 || item.status == 10) {
      if (item.progress == "国家新闻出版署" || item.progress == "登记") {
        return { color: "#4fb000", fontWeight: "bold" };
      } else {
        return { color: "#a2a2a2" };
      }
    },
  },
  created: function () {
    console.debug("created: ", this.$route.query);
    if (this.$route.query.pvcId) {
      this.postDat.sjExamineId = this.$route.query.pvcId;
    }
    this.resizeSet();

    getFileToken().then((response) => {
      this.fileToken = response.resultStatus.token;
      this.resizeSet();
      this.provinceSet();
    });
  },
  mounted: function () {
    let vm = this;

    // window.onresize = function() {
    //     vm.screenHeight = document.documentElement.clientHeight;
    // }
  },
};
</script>

<style lang="scss">
@import "src/styles/provinceCom";

.admin-2 {
  position: relative;

  .provinceArea {
    width: 240px;
    height: 100%;
    overflow: hidden;
    position: absolute;
    left: 0;
    border-right: 1px solid #e8e8e8;

    .el-scrollbar {
      height: 100%;
      padding-bottom: 5px;
      overflow-x: hidden;
    }

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-menu-item {
      height: 50px;
      line-height: 50px;
    }

    .el-menu {
      border-right: none;
    }
  }

  .unProvince {
    margin-left: 240px;
    padding: 20px;
    font-size: 16px;
    color: #999999;
    letter-spacing: 0.72px;
  }

  .contArea {
    margin-left: 240px;
    padding: 9px;
    font-size: 14px;
    letter-spacing: 0.72px;

    .ttBar {
      height: 45px;
      line-height: 45px;
      background: #f8f8f8;
      font-size: 14px;
      padding: 0 20px;
      color: #666666;
      font-weight: bold;
      position: relative;
      z-index: 2;

      .btnCtrls {
        float: right;

        .el-button {
          width: 112px;
        }
      }
    }
  }

  .ctrlsBar {
    height: 32px;
  }
}
</style>

<style>
.admin_audio_pop .el-dialog__body {
  padding: 12px 20px;
}

.admin_audio_pop .ppttl {
  margin-bottom: 12px;
  font-size: 16px;
}

.admin_audio_pop textarea {
  resize: none;
  border-radius: 0px;
}

/* 自定义激活类（备用方案） */
.custom-active {
  background: linear-gradient(270deg, rgb(241, 241, 241), rgb(241, 241, 241)) !important;
  /* color: #2e95fb !important;  */
}
</style>



// WEBPACK FOOTER //
// audioFExam.vue?1bce9387